import type { RJSFSchema } from "@rjsf/utils";

export const schema: RJSFSchema = {
  type: "object",
  properties: {
    name: {
      type: "object",
      patternProperties: {
        "^[a-zA-Z]{2,3}$": {
          type: "string",
          minLength: 1,
        },
      },
    },
    id: {
      type: "integer",
      readOnly: true,
    },
    description: {
      type: "object",
      patternProperties: {
        "^[a-zA-Z]{2,3}$": {
          type: "string",
        },
      },
    },
    availability_url: {
      type: "string",
      format: "url",
    },
    logo: {
      $ref: "#/definitions/global/Media",
    },
    main_image: {
      $ref: "#/definitions/global/Media",
    },
    location: {
      type: ["object", "null"],
    },
  },
  required: ["name"],
};
